import React from 'react'
import { DropdownButton } from 'components'
import ExportButton, { ExportButtonProps } from 'features/export_import/ExportButton'
import ImportDataForm from 'features/export_import/ImportDataForm'
import { _ } from 'utils'
import { useDispatch } from 'react-redux'
import { addModal } from 'features/modals/modalSlice'
import styled from 'styled-components'
import { setIsMinimizing } from 'features/export_import/importExportSlice'
import { ImportDataFormProps } from 'features/export_import/types'

const S = {
    DropdownButton: styled(DropdownButton)`
        & > div:first-child {
            padding: 5px 28px 5px 10px;
        }
    `,
}

export interface BulkActionsProps {
    multipleImport?: ImportDataFormProps[]
    importProps?: ImportDataFormProps
    exportProps?: ExportButtonProps
    onDelete?: (data?: any) => void
    isMultiSelect?: boolean
    setIsMultiSelect?: (data: boolean) => void
}

const BulkActions = ({
    multipleImport = [],
    importProps,
    exportProps,
    onDelete,
    isMultiSelect,
    setIsMultiSelect,
}: BulkActionsProps) => {
    const dispatch = useDispatch()
    const handleImportData = (_importProps: ImportDataFormProps) => {
        dispatch(setIsMinimizing(false))
        dispatch(
            addModal({
                header: _('list.import_header'),
                Component: ({ close }: { close: () => void }) => (
                    <ImportDataForm {..._importProps} close={close} />
                ),
                backdrop: 'static',
            })
        )
    }
    return (
        <S.DropdownButton name={_('list.bulk_actions')}>
            {multipleImport.map((e, index) => (
                <div key={index} onClick={() => handleImportData(e)}>{e.title}</div>
            ))}
            {importProps && (
                <div onClick={() => handleImportData(importProps)}>{_('list.bulk_actions_import')}</div>
            )}
            {exportProps && <ExportButton {...exportProps}>{_('list.bulk_actions_export')}</ExportButton>}
            {onDelete && <div onClick={onDelete}>{_('list.bulk_actions_delete')}</div>}
            {setIsMultiSelect && (
                <div onClick={() => setIsMultiSelect(!isMultiSelect)}>
                    {isMultiSelect ? _('list.bulk_actions_singleselect') : _('list.bulk_actions_multiselect')}
                </div>
            )}
        </S.DropdownButton>
    )
}

export default BulkActions
